import { render, staticRenderFns } from "./messages-view.html?vue&type=template&id=b70b11a4&"
import script from "./messages-view.js?vue&type=script&lang=js&"
export * from "./messages-view.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports